import React, {Component} from 'react';
import PureComponent from 'ROOT/src/components/pure';

import sAction from 'sAction';
import TickBox from 'ROOT/src/components/formElements/TickBox';
class PortalAdminDraggable extends React.Component {
    render() {
        const type = this.props.type;
        let tickComp = null;
        let iconName = '';
        let pomClass = '';
        let addComp = null;
        if (type == 'ROLES') {
            iconName = 'icon-plusIcon';
            pomClass = ' rolesDrag';
            if (!isNaN(this.props.usersCnt)) {
                addComp = <div className="portalAdminAddComp">
                    <span>({this.props.usersCnt})</span>
                    <span onClick={() => window.open('#detail/acm_portal_roles/'+this.props.record, '_blank')} className="portalExpand icon-expandIcon"></span>
                </div>;
            }
        } else if (type == 'USERS') {
            iconName = 'icon-Users';
            pomClass = ' usersDrag';
            if (!isNaN(this.props.index)) {
                pomClass += ' userNonDrag';
            } else {
                tickComp = <TickBox
                    className="portalAdminTick"
                    onChange={(value) => this.props.selectUser(this.props.record, value)}
                    checked={this.props.checkedUser}
                />;
                addComp = <div className="portalAdminAddComp">
                    <span>({this.props.branch})</span>
                    <span onClick={() => window.open('#detail/acm_portal_users/'+this.props.record, '_blank')} className="portalExpand icon-expandIcon"></span>
                </div>;
            }
        }

        const deleteComp = null;

        const indClass = this.props.index % 2 == 0 ? ' evenRow' : '';

        return <div id={this.props.compId} className={'dragableItem' + (this.props.isDragging ? ' isDragging' : '')+pomClass+ ' '+this.props.customDragClass+indClass}>
            {tickComp}
            <span className={'dragableItemIcon '+iconName} />
            {this.props.name}
            {addComp}
            {(this.props.onDelete) &&
                <span className="icon-deleteIcon portalAdminDelIcon" onClick={() => {
                    this.props.onDelete({
                        bId: this.props.bId,
                        rId: this.props.rId,
                        uId: this.props.uId,
                    });
                }}/>
            }
        </div>;
    }
}
export default PortalAdminDraggable;
